export const calculateAttachRateMeasureRDP = (column: any) => {
  const keys =[
  'RDPFinalActToGoTotalAttachRatePct',
  'RDPToGoTotalFcst',
  'HeroRDPActToGoTotalFcst'
];
keys.forEach((key) => {
  if (column['measures'][key] !== 'Multiple %') {
    column['measures'][key] = +(column['measures'][key] || 0)
      .toString()
      .replaceAll(',', '');
  }
});
if (column['measures']['HeroRDPActToGoTotalFcst'] == 0) {
  column['measures']['RDPFinalActToGoTotalAttachRatePct'] = 0;
  return;
}
  column['measures']['RDPFinalActToGoTotalAttachRatePct'] = column['measures']['RDPToGoTotalFcst'] / column['measures']['HeroRDPActToGoTotalFcst'] * 100
  if (column['measures']['RDPFinalActToGoTotalAttachRatePct'] !== 'Multiple %') {
    column['measures']['RDPFinalActToGoTotalAttachRatePct'] = column['measures']['RDPFinalActToGoTotalAttachRatePct'].toString().replaceAll('%', '');
    column['measures']['RDPFinalActToGoTotalAttachRatePct'] = column['measures']['RDPFinalActToGoTotalAttachRatePct'];
  }
}
